
import React from "react";
import { ArrowRight } from "lucide-react";
import { SectionHeader } from "@/components/ui/section-header";
import { BlogCard } from "@/components/ui/blog-card";
import { blogPosts } from "@/data/blog-posts";
import { BookOpen } from "lucide-react";

export default function BlogHighlights() {
  return (
    <section className="py-20 bg-grandpal-green-lighter">
      <div className="container">
        <div className="flex items-center justify-between mb-12">
          <div>
            <div className="flex items-center gap-3 mb-2">
              <BookOpen className="w-6 h-6 text-grandpal-green-dark" />
              <span className="text-sm font-medium uppercase tracking-wider text-grandpal-green-dark">Our Knowledge Hub</span>
            </div>
            <SectionHeader 
              title="Latest from Our Blog" 
              subtitle="Helpful articles, guides, and resources for navigating elderly care in Ireland." 
            />
          </div>
          <a href="/blog" className="hidden md:flex items-center text-grandpal-green hover:text-grandpal-green-dark transition-colors duration-200">
            View all articles
            <ArrowRight className="ml-2 h-4 w-4" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 animate-fade-in">
          {blogPosts.map(post => (
            <BlogCard 
              key={post.id}
              title={post.title}
              excerpt={post.excerpt}
              slug={post.slug}
              date={post.date}
              imageUrl={post.imageUrl}
              categories={post.categories}
            />
          ))}
        </div>

        <div className="mt-10 text-center md:hidden">
          <a href="/blog" className="inline-flex items-center text-grandpal-green hover:text-grandpal-green-dark transition-colors duration-200">
            View all articles
            <ArrowRight className="ml-2 h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
